export function extractYearFromDate(date: Date){
    return date.getFullYear()
}

export function dateFromMonthYear(monthYear: string) {
    return new Date(monthYear);
}